// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"a847a71f3b4ff80a9512","223":"3f920a93cd97b9a76a0c","293":"0fd235ad2b4647de1a56","522":"f4fee4cde494a7eb5204"}[chunkId] + ".js";
};